import React, { useState, useEffect, useMemo } from "react";
import Modal from "components/Modal";
import PdfViewer from "common/PdfViewer";

const ViewInvoiceCost = ({ billInfo, handleClick }) => {
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);

  console.log('billInfo--',billInfo);

  const getFile = async () => { 
    try {
      const response = await fetch(billInfo?.billLink);
      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer], 
        
        { type: response.headers.get('content-type') === '.jpg' ? 'image/jpg' :
          response.headers.get('content-type') === '.png' ? 'image/png':
          response.headers.get('content-type') === '.jpeg' ? 'image/jpeg':
          response.headers.get('content-type')});

      const url = window.URL.createObjectURL(blob);  
      setFileUrl(url);
      setFileType(response.headers.get('content-type'));
    } catch (error) {
      console.error('Error fetching the file:', error);
    }
  };

  useMemo(() => {
    if (billInfo?.billLink) getFile();
  }, [billInfo?.billLink]);


  return (
    <Modal
      handleClick={handleClick}
      title="Invoice Cost Details"
      className="max-w-3xl"
    >
      <div className="flex flex-col m-2 lg:m-2">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr className="py-2">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Bill Number
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Bill Date
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Uploaded By
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Bill Amount
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">

                  <tr className="bg-gray-100 h-10">
                    <td className="px-6 py-4 whitespace-nowrap">{billInfo?.billNumber || "N/A"}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{billInfo?.receivedDate || "N/A"}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{billInfo?.billUploadedBy || "N/A"}</td>
                    <td className="px-6 py-4 whitespace-nowrap">₹{billInfo?.billAmount || "N/A"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <h1 className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider bg-white text-center">Uploaded Bill Document</h1>

      <div className="w-full flex flex-col md:flex-row justify-between mb-10 border-2 shadow-md rounded-sm p-1">
        {fileUrl && (
          fileType === 'application/pdf' || fileType === '.pdf' ? (
            <PdfViewer pdfBytes={fileUrl} />
          ) : (
            <iframe src={fileUrl} alt="No image found" height="400px" width="100%" title="Document Viewer" style={{ overflow: 'hidden' }} />
          )
        )}
      </div>

    </Modal>
  );
};

export default ViewInvoiceCost;